export type ContentFitnessDimension = {
  key: string;
  label: string;
  weight: number;
  order: number;
  description: string;
};

/**
 * The five client-facing Content Fitness dimensions. Each key is a metric
 * catalog key in `public.metrics`; subcriteria hang beneath these.
 */
export const CONTENT_FITNESS_DIMENSIONS = [
  {
    key: "human_first_content_quality",
    label: "Human-First Content Quality",
    weight: 25,
    order: 1,
    description:
      "Is the content clear, useful, natural, trustworthy and written for humans first?",
  },
  {
    key: "content_design_orientation",
    label: "Content Design & Orientation",
    weight: 25,
    order: 2,
    description:
      "Is the page structured so humans, search engines and AI systems can all understand it?",
  },
  {
    key: "ai_agent_readiness",
    label: "AI Agent Readiness",
    weight: 20,
    order: 3,
    description:
      "Can AI systems and agents access, read, parse, cite and act on the page with the brand as the source?",
  },
  {
    key: "journey_usability_action",
    label: "Journey, Usability & Action",
    weight: 15,
    order: 4,
    description:
      "Does the page serve the right user at the right moment and make the next useful step clear?",
  },
  {
    key: "brand_trust_consistency",
    label: "Brand, Trust & Consistency",
    weight: 15,
    order: 5,
    description:
      "Does the page feel credible, on-brand and consistent with active guidance?",
  },
] as const satisfies readonly ContentFitnessDimension[];

export type ContentFitnessDimensionKey =
  (typeof CONTENT_FITNESS_DIMENSIONS)[number]["key"];
